import React from 'react';
import Icon from '../../../components/AppIcon';

const RelationshipCard = ({ profile, onEdit, onRemove }) => {
  const getRelationshipIcon = (relationship) => {
    const icons = {
      parent: 'Users',
      child: 'Baby',
      spouse: '/assets/images/MyBodyToday_logo_design2-removebg-preview1-1770673381636.png',
      sibling: 'Users',
      caregiver: 'UserCheck',
      self: 'User',
      other: 'User'
    };
    return icons?.[relationship] || 'User';
  };

  const formatDate = (date) => {
    if (!date) return 'Not specified';
    const d = new Date(date);
    return d?.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  };

  const getAgeDisplay = (age, dateOfBirth) => {
    if (age) return `${age} years old`;
    if (dateOfBirth) {
      const birthDate = new Date(dateOfBirth);
      const today = new Date();
      const calculatedAge = today?.getFullYear() - birthDate?.getFullYear();
      return `${calculatedAge} years old`;
    }
    return 'Age not specified';
  };

  return (
    <div className="bg-card rounded-xl border border-border shadow-therapeutic p-4 sm:p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-primary/10 flex items-center justify-center">
          {profile?.avatarUrl ? (
            <img 
              src={profile?.avatarUrl} 
              alt={`${profile?.name} avatar`}
              className="w-full h-full rounded-full object-cover"
            />
          ) : (
            <Icon 
              name={getRelationshipIcon(profile?.relationship)} 
              size={28} 
              className="text-primary"
              strokeWidth={2}
            />
          )}
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-3">
            <div>
              <h3 className="text-lg sm:text-xl font-heading font-semibold text-foreground line-clamp-1">
                {profile?.name}
              </h3>
              <p className="text-sm text-muted-foreground capitalize">
                {profile?.relationship?.replace('_', ' ')}
              </p>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onEdit(profile)}
                className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted transition-smooth focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
                aria-label="Edit profile"
              >
                <Icon name="Edit2" size={18} strokeWidth={2} />
              </button>
              <button
                onClick={() => onRemove(profile)}
                className="p-2 rounded-lg text-muted-foreground hover:text-error hover:bg-error/10 transition-smooth focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-background"
                aria-label="Remove profile"
              >
                <Icon name="Trash2" size={18} strokeWidth={2} />
              </button>
            </div>
          </div>

          <div className="space-y-2">
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Calendar" size={16} className="text-muted-foreground" strokeWidth={2} />
              <span className="text-foreground">{getAgeDisplay(profile?.age, profile?.dateOfBirth)}</span>
            </div>

            {profile?.gender && (
              <div className="flex items-center gap-2 text-sm">
                <Icon name="User" size={16} className="text-muted-foreground" strokeWidth={2} />
                <span className="text-foreground capitalize">{profile?.gender?.replace('_', ' ')}</span>
              </div>
            )}

            {profile?.bloodGroup && (
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Droplet" size={16} className="text-error" strokeWidth={2} />
                <span className="text-foreground">{profile?.bloodGroup?.toUpperCase()?.replace('-', ' ')}</span>
              </div>
            )}

            <div className="flex items-center gap-2 text-sm">
              <Icon name="Clock" size={16} className="text-muted-foreground" strokeWidth={2} />
              <span className="text-muted-foreground">Added {formatDate(profile?.createdAt)}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelationshipCard;